<template>
  <span
    class="text-xs font-medium text-center text-white uppercase rounded-t z-2"
    :class="{
      'bg-orange-700': listingIs.wanted,
      'bg-red-500': listingIs.dead || listingIs.sold,
      'bg-blue-800': listingIs.premium && !listingIs.dead,
      'bg-auction text-primary': listingIs.auction && !listingIs.dead,
      'bg-brand-darker': listingIs.forSale && !listingIs.wanted && !listingIs.auction && !listingIs.premium,
      'py-4px': !compact,
      'py-1px': compact
    }"
  >
    <span v-if="listingIs.wanted">WANTED</span>
    <span v-else-if="listingIs.dead">SOLD</span>
    <span v-else-if="listingIs.auction">
      <FontAwesomeIcon v-if="showIcon" :icon="faGavel" class="mr-2px" />
      AUCTION
    </span>
    <span v-else-if="listingIs.premium">
      <FontAwesomeIcon v-if="showIcon" :icon="faStar" class="mr-2px" />
      PREMIUM LISTING
    </span>
    <span v-else-if="listingIs.forSale">FOR SALE</span>
    <span v-else>SOLD</span>
  </span>
</template>

<script>
import { faGavel, faStar } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'UtilListingType',

  props: {
    listingIs: {
      type: Object,
      required: true
    },

    showIcon: {
      type: Boolean,
      default: true
    },

    compact: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      faGavel,
      faStar
    }
  }
}
</script>
